import { FC } from 'react';
import { IoNotificationsOutline } from 'react-icons/io5';
import { Badge } from '@heroui/react';

interface NotificationIconProps {
  count: number;
  size?: number;
  className?: string;
}

export const NotificationIcon: FC<NotificationIconProps> = ({
  count,
  size = 24,
  className = '',
}) => {
  return (
    <Badge
      color="primary"
      shape="circle"
      size="md"
      className={className}
      content={count}
      placement="top-left"
      variant="faded"
      isInvisible={count === 0}
    >
      <IoNotificationsOutline size={size} />
    </Badge>
  );
};

export default NotificationIcon; 